// src/pages/materias/laboral/LaboralProcedimientoPage/LaboralProcedimientoPage.jsx

import React, { useMemo, useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { printLaboralReportPdf, previewLaboralReportPdf } from "../../components/utils/printLaboralReportPdf";
import { useDispatch, useSelector } from "react-redux";
import ImportarExcelModal from "./utils/ImportarExcelModal.jsx";
import ImportarAIModal from "./utils/ImportarAIModal.jsx";

import { Button, Modal, Dropdown, Card, Row, Col, Select, Input, Table, Segmented, Alert, ConfigProvider } from "antd";
import ScrollDatePicker from "../../components/calendar/ScrollDatePicker";
import esES from "antd/locale/es_ES";
import { HappyProvider } from "@ant-design/happy-work-theme";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { notify, fromDateInputValue, DataBadge, AppPagination } from "../../components/ui";
import { usePermisos } from "../../context/PermisosContext";

import axios from "axios";

import { actionAutoridadesGet } from "../../redux/actions/autoridades/autoridades";
import { actionConciliacionGet } from "../../redux/actions/conciliacion/conciliacion";

// AJUSTA ESTE IMPORT A TU RUTA REAL:
import { actionEmpresasdistinct } from "../../redux/actions/empresas/empresas";
import { laboralTiposConfig, PAGE_SIZE } from "./materias/laboral/laboralProcedimiento.config.js";
import useLaboralCatalogos from "./materias/laboral/useLaboralCatalogos";
import useExpedientesProcedimiento from "./materias/laboral/useExpedientesProcedimiento";
import useDefaultCiudadUsuario from "./materias/laboral/useDefaultCiudadUsuario";
import "./materias/laboral/LaboralProcedimientoPage.css";
import "../../components/tribunal/TribunalPage.css";
import "../../components/tribunal/TribunalTablePage.css";

dayjs.locale("es");

const ALL = "__all__";

const API_BASE = `/api`;
const apiServiceGet = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/* =========================
   Helpers (mismo patrón que Wizard)
   ========================= */
const coerceItems = (slice) => {
  if (!slice) return [];
  const data = slice.data ?? slice;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.items)) return data.items;
  return [];
};

const collapseSpaces = (str) => String(str || "").replace(/\s+/g, " ").trim();
;

const pickCompanyName = (it) =>
  it?.nombre ??
  it?.nombre_cliente ??
  it?.empresa ??
  it?.name ??
  it?.razon_social ??
  it?.empresa_nombre ??
  "";

// Efecto "inset" (onda que crece desde el punto de clic) para todos los
// botones de esta página, excepto Crear que usa HappyProvider aparte.
const createWaveHolder = (node) => {
  const { borderWidth } = getComputedStyle(node);
  const borderWidthNum = Number.parseInt(borderWidth, 10) || 0;
  const div = document.createElement("div");
  div.style.position = "absolute";
  div.style.inset = `-${borderWidthNum}px`;
  div.style.borderRadius = "inherit";
  div.style.background = "transparent";
  div.style.zIndex = "999";
  div.style.pointerEvents = "none";
  div.style.overflow = "hidden";
  node.appendChild(div);
  return div;
};

const createWaveDot = (holder, color, left, top, size = 0) => {
  const dot = document.createElement("div");
  dot.style.position = "absolute";
  dot.style.insetInlineStart = `${left}px`;
  dot.style.top = `${top}px`;
  dot.style.width = `${size}px`;
  dot.style.height = `${size}px`;
  dot.style.borderRadius = "50%";
  dot.style.background = color;
  dot.style.transform = "translate3d(-50%, -50%, 0)";
  dot.style.transition = "all 1s ease-out";
  holder.appendChild(dot);
  return dot;
};

const showInsetEffect = (node, { event, component }) => {
  if (component !== "Button") return;
  const holder = createWaveHolder(node);
  const rect = holder.getBoundingClientRect();
  const left = event.clientX - rect.left;
  const top = event.clientY - rect.top;
  const dot = createWaveDot(holder, "rgba(10, 83, 154, 0.35)", left, top);
  requestAnimationFrame(() => {
    dot.ontransitionend = () => {
      holder.remove();
    };
    dot.style.width = "200px";
    dot.style.height = "200px";
    dot.style.opacity = "0";
  });
};

export default function LaboralProcedimientoPage() {
  const { tipo } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  const { perm, allowedCities } = usePermisos() || { perm: () => true, allowedCities: () => null };
  const canConsultar = perm("conciliacion", "consultar");

  const getParam = (k) => {
    const v = searchParams.get(k);
    return v === null ? null : v;
  };

  const toIntOrNull = (v) => {
    if (v === null || v === undefined) return null;
    const n = Number(String(v).trim());
    return Number.isFinite(n) ? n : null;
  };
const [exportPreviewOpen, setExportPreviewOpen] = useState(false);
const [exportPreviewHtml, setExportPreviewHtml] = useState("");
  const tipoConfig = laboralTiposConfig[tipo] || laboralTiposConfig["centro-conciliacion"];

  // Ciudades permitidas al usuario para el módulo Centro de Conciliación
  // (null = todas; ver columna "Ciudades" en Usuarios > Permisos).
  const allowedCiudadesConciliacion = allowedCities("conciliacion");
  const canInsertar =
    perm("conciliacion", "insertar") &&
    (tipoConfig.key !== "centro-conciliacion" ||
      allowedCiudadesConciliacion === null ||
      allowedCiudadesConciliacion.length > 0);

  const concSlice = useSelector((state) => state.conciliacion || {});

  const autoridadesSlice = useSelector((state) => state.autoridades || {});
const [importModalOpen, setImportModalOpen] = useState(false);
const [importAIModalOpen, setImportAIModalOpen] = useState(false);
const [view, setView] = useState("cards");
const [sortOption, setSortOption] = useState("default");

  const statusById = useMemo(() => {
    const src = concSlice?.statusCatalog?.items || [];
    return src.reduce((acc, s) => {
      acc[s.id] = s;
      return acc;
    }, {});
  }, [concSlice]);

  // empresas distinct (NO Redux)
  const [empresasOptionsDistinct, setEmpresasOptionsDistinct] = useState([]);

  // ======= leer estado inicial desde URL =======
  const initialEstadoId = toIntOrNull(getParam("estado"));
  const initialCiudadId = toIntOrNull(getParam("ciudad"));
  const initialAutoridadId = toIntOrNull(getParam("autoridad"));
  const initialEmpresa = getParam("empresa"); // puede ser id o nombre
  const initialSearch = getParam("q") || "";
  const initialStatus = getParam("status") || "activos";
  const initialPage = toIntOrNull(getParam("page")) || 1;

  const d1 = getParam("d1"); // YYYY-MM-DD
  const d2 = getParam("d2"); // YYYY-MM-DD
  const initialDateRange = d1 && d2 ? [fromDateInputValue(d1), fromDateInputValue(d2)] : null;

  // ======= states =======
  const [selectedEstadoId, setSelectedEstadoId] = useState(initialEstadoId ?? ALL);
const [selectedCiudadId, setSelectedCiudadId] = useState(initialCiudadId ?? ALL);
const [selectedAutoridadId, setSelectedAutoridadId] = useState(initialAutoridadId ?? ALL);

  const [selectedAutoridadData, setSelectedAutoridadData] = useState(null);

  const [search, setSearch] = useState(initialSearch);
const [searchDebounced, setSearchDebounced] = useState(initialSearch);

useEffect(() => {
  const t = setTimeout(() => {
    setSearchDebounced(search);
  }, 350); // 250-400ms funciona bien

  return () => clearTimeout(t);
}, [search]);


// subfiltros por sección
const initialSubAct = getParam("sub_act") || "todos";
const initialSubConv = getParam("sub_conv") || "todos";
const initialSubConc = getParam("sub_conc") || "todos";

const [statusFilter, setStatusFilter] = useState(initialStatus);

const [activosSubFilter, setActivosSubFilter] = useState(initialSubAct);
const [conveniosSubFilter, setConveniosSubFilter] = useState(initialSubConv);
const [concluidosSubFilter, setConcluidosSubFilter] = useState(initialSubConc);

  const [fueroFilter] = useState("todos");
  const [empresaFilter, setEmpresaFilter] = useState(initialEmpresa);
  const [dateRange, setDateRange] = useState(initialDateRange);
  const [currentPage, setCurrentPage] = useState(initialPage);

  // catálogos (estados/ciudades/empresas)
  const estadoIdForCatalogos = selectedEstadoId === ALL ? null : selectedEstadoId;
const ciudadIdForCatalogos = selectedCiudadId === ALL ? null : selectedCiudadId;

const {
  estadosOptions,
  ciudadesOptions,
  empresasOptions,
  estadoSeleccionado,
  ciudadSeleccionada,
  estadosById,
  ciudadesById,
} = useLaboralCatalogos(estadoIdForCatalogos, ciudadIdForCatalogos, {
  modulo: tipoConfig.key === "centro-conciliacion" ? "conciliacion" : undefined,
});

  // Ciudad por default según lo asignado al usuario (1 ciudad -> esa; varias
  // -> San Luis Río Colorado si está entre ellas, si no la primera alfabética).
  // Solo aplica si no vino ya un estado/ciudad explícito por la URL.
  const { defaultCiudad, loaded: ciudadUsuarioLoaded } = useDefaultCiudadUsuario();
  const defaultCiudadAppliedRef = useRef(false);

  useEffect(() => {
    if (defaultCiudadAppliedRef.current) return;
    if (!ciudadUsuarioLoaded) return;
    if (!defaultCiudad) {
      defaultCiudadAppliedRef.current = true;
      return;
    }
    if (!ciudadesById || Object.keys(ciudadesById).length === 0) return;

    if (selectedEstadoId !== ALL || selectedCiudadId !== ALL) {
      defaultCiudadAppliedRef.current = true;
      return;
    }

    defaultCiudadAppliedRef.current = true;
    const idCiudad = Number(defaultCiudad.id_ciudad);
    if (!Number.isFinite(idCiudad)) return;

    setSelectedCiudadId(idCiudad);
    const city = ciudadesById?.[String(idCiudad)] || ciudadesById?.[idCiudad];
    const idEstado = city?.id_estado ?? city?.idEstado ?? null;
    if (idEstado !== undefined && idEstado !== null && String(idEstado) !== "") {
      setSelectedEstadoId(Number(idEstado));
    }
    setCurrentPage(1);
  }, [ciudadUsuarioLoaded, defaultCiudad, ciudadesById, selectedEstadoId, selectedCiudadId]);

  useEffect(() => {
    dispatch(actionAutoridadesGet({}));
  }, [dispatch]);
const handleExportNow = () => {
  const list = Array.isArray(filteredExpedientes) ? filteredExpedientes : [];

  const now = new Date();
  const y = now.getFullYear();

  const periodFrom = dateRange?.[0]
    ? dayjs(dateRange[0]).format("YYYY-MM-DD")
    : `${y}-01-01`;

  const periodTo = dateRange?.[1]
    ? dayjs(dateRange[1]).format("YYYY-MM-DD")
    : `${y}-12-31`;

  const ciudadesLabel =
    selectedCiudadId === ALL ? "Todas" : (ciudadSeleccionada?.nombre || "—");

const nombreEmpresa = collapseSpaces(search) || "Todas";  // ✅ oxxo, etc.

const html = previewLaboralReportPdf({
  items: list,
  periodFrom,
  periodTo,
  ciudadesLabel,
  nombreEmpresa,
});

setExportPreviewHtml(html);
setExportPreviewOpen(true);
}

  const autoridadesItems = useMemo(() => coerceItems(autoridadesSlice), [autoridadesSlice]);

  // Set de ciudades que SI tienen autoridades (para filtrar solo en centro-conciliación)
  const ciudadIdsConAutoridad = useMemo(() => {
    const s = new Set();
    (autoridadesItems || []).forEach((au) => {
      const idc = au?.id_ciudad;
      if (idc !== undefined && idc !== null && String(idc) !== "") {
        s.add(Number(idc));
      }
    });
    return s;
  }, [autoridadesItems]);

  // ✅ Set de estados que SI tienen al menos una ciudad con autoridad
  // (para filtrar solo en centro-conciliación). `ciudadIdsConAutoridad` y
  // `ciudadesById` ya vienen filtradas por el permiso de ciudades del
  // módulo desde el backend (/autoridades y /ciudades con ?modulo=
  // conciliacion), así que no hace falta filtrar de nuevo aquí.
  const estadoIdsConAutoridad = useMemo(() => {
    const s = new Set();
    if (tipoConfig.key !== "centro-conciliacion") return s;

    ciudadIdsConAutoridad.forEach((idCiudad) => {
      const c = ciudadesById?.[String(idCiudad)] || ciudadesById?.[Number(idCiudad)];
      const idEstado = c?.id_estado ?? c?.idEstado ?? null;
      if (idEstado !== undefined && idEstado !== null && String(idEstado) !== "") {
        s.add(Number(idEstado));
      }
    });
    return s;
  }, [tipoConfig.key, ciudadIdsConAutoridad, ciudadesById]);

  // ✅ FILTRO de estados SOLO para Centro de Conciliación

const estadosOptionsFinal = useMemo(() => {
  const base = Array.isArray(estadosOptions) ? estadosOptions : [];
  const filtered =
    tipoConfig.key === "centro-conciliacion"
      ? base.filter((o) => estadoIdsConAutoridad.has(Number(o.value)))
      : base;

  return [{ label: "Todos los estados", value: ALL }, ...filtered];
}, [estadosOptions, tipoConfig.key, estadoIdsConAutoridad]);
  // ✅ FILTRO de ciudades SOLO para Centro de Conciliación
const ciudadesOptionsFinal = useMemo(() => {
  // Base: TODAS las ciudades conocidas (no depende de tener un estado elegido)
  const baseAll = Object.values(ciudadesById || {}).map((c) => ({
    label: c.nombre ?? c.code ?? `Ciudad ${c.id}`,
    value: c.id,
  }));

  // Si hay estado elegido, acota a las ciudades de ese estado
  const byEstado =
    selectedEstadoId === ALL
      ? baseAll
      : baseAll.filter((o) => {
          const city = ciudadesById?.[String(o.value)] || ciudadesById?.[Number(o.value)];
          const idEstado = city?.id_estado ?? city?.idEstado ?? null;
          return Number(idEstado) === Number(selectedEstadoId);
        });

  // Si es centro-conciliacion, además filtra a ciudades con autoridad.
  // `ciudadIdsConAutoridad`/`ciudadesById` ya vienen filtradas por el
  // permiso del módulo desde el backend.
  const filtered =
    tipoConfig.key === "centro-conciliacion"
      ? byEstado.filter((o) => ciudadIdsConAutoridad.has(Number(o.value)))
      : byEstado;

  return [{ label: "Todas las ciudades", value: ALL }, ...filtered];
}, [
  ciudadesById,
  tipoConfig.key,
  ciudadIdsConAutoridad,
  selectedEstadoId,
]);

// Autoridad: filtrada en cascada -> si hay ciudad elegida, solo esa ciudad;
// si solo hay estado elegido (sin ciudad), todas las autoridades de ese estado;
// si no hay nada elegido, catálogo completo. `autoridadesItems` ya viene
// filtrada por el permiso del módulo desde el backend.
const autoridadOptions = useMemo(() => {
  const base = (autoridadesItems || [])
    .filter((au) => {
      if (selectedCiudadId !== ALL) {
        return Number(au?.id_ciudad || 0) === Number(selectedCiudadId);
      }
      if (selectedEstadoId !== ALL) {
        const city = ciudadesById?.[String(au?.id_ciudad)] || ciudadesById?.[Number(au?.id_ciudad)];
        const idEstado = city?.id_estado ?? city?.idEstado ?? null;
        return Number(idEstado) === Number(selectedEstadoId);
      }
      return true;
    })
    .map((au) => ({
      label: collapseSpaces(au?.nombre || ""),
      value: au?.id,
      data: au,
    }))
    .filter((o) => o.label);

  return [{ label: "Todas las autoridades", value: ALL, data: null }, ...base];
}, [autoridadesItems, selectedCiudadId, selectedEstadoId, ciudadesById]);


useEffect(() => {
  if (tipoConfig.key !== "centro-conciliacion") return;
  if (selectedEstadoId === ALL) return;
  if (!selectedEstadoId) return;

  // 🔒 si aún no hay datos "confiables", NO resetees
  if (!estadoIdsConAutoridad || estadoIdsConAutoridad.size === 0) return;

  if (!estadoIdsConAutoridad.has(Number(selectedEstadoId))) {
    setSelectedEstadoId(ALL);
    setSelectedCiudadId(ALL);
    setSelectedAutoridadId(ALL);
    setSelectedAutoridadData(null);
    setEmpresaFilter(null);
    setCurrentPage(1);
  }
}, [tipoConfig.key, selectedEstadoId, estadoIdsConAutoridad]);

useEffect(() => {
  if (tipoConfig.key !== "centro-conciliacion") return;
  if (selectedCiudadId === ALL) return;
  if (!selectedCiudadId) return;

  // 🔒 igual aquí
  if (!ciudadIdsConAutoridad || ciudadIdsConAutoridad.size === 0) return;

  if (!ciudadIdsConAutoridad.has(Number(selectedCiudadId))) {
    setSelectedCiudadId(ALL);
    setSelectedAutoridadId(ALL);
    setSelectedAutoridadData(null);
    setEmpresaFilter(null);
    setCurrentPage(1);
  }
}, [tipoConfig.key, selectedCiudadId, ciudadIdsConAutoridad]);

  /* =========================
     DEFAULTS: Estado/Ciudad (primero) + Autoridad SOLO si hay 1
     ========================= */
useEffect(() => {
  if (selectedEstadoId == null) {
    setSelectedEstadoId(ALL);
    setSelectedCiudadId(ALL);
    setSelectedAutoridadId(ALL);
    setSelectedAutoridadData(null);
  }
}, [selectedEstadoId]);




useEffect(() => {
  const disponibles = Array.isArray(autoridadOptions) ? autoridadOptions : [];
  if (!disponibles.length) return;

  // Si ya es válido, no toques nada
  const exists = disponibles.some((o) => String(o.value) === String(selectedAutoridadId));
  if (exists) return;

  // Si NO existe, fuerza ALL (no "la primera") para evitar brincos raros
  setSelectedAutoridadId(ALL);
  setSelectedAutoridadData(null);
}, [autoridadOptions, selectedAutoridadId]);


const handleChangeEstado = (value) => {
  const v = value ?? ALL;

  setSelectedEstadoId(v);

  // si cambias estado -> ciudad a ALL por defecto
  setSelectedCiudadId(ALL);

  // autoridad siempre seleccionada
  setSelectedAutoridadId(ALL);
  setSelectedAutoridadData(null);

  setEmpresaFilter(null);
  setCurrentPage(1);
};

  const handleChangeCiudad = (value) => {
  const v = value ?? ALL;

  setSelectedCiudadId(v);

  // ✅ autorellena ESTADO a partir de la ciudad elegida (pero NO autoridad,
  // porque una ciudad puede tener varias autoridades)
  if (v !== ALL) {
    const city = ciudadesById?.[String(v)] || ciudadesById?.[Number(v)];
    const idEstado = city?.id_estado ?? city?.idEstado ?? null;
    if (idEstado !== undefined && idEstado !== null && String(idEstado) !== "") {
      setSelectedEstadoId(Number(idEstado));
    }
  }

  // autoridad se define en el effect de abajo (primera opción)
  setSelectedAutoridadId(ALL);
  setSelectedAutoridadData(null);

  setEmpresaFilter(null);
  setCurrentPage(1);
};


  /* =========================
     filtros backend (mantengo tu flujo: estado+ciudad+tipo)
     AHORA: también manda empresa + expediente
     ========================= */
const filtrosBusqueda = useMemo(() => {
  const term = collapseSpaces(searchDebounced);

  const isNumericLike = (v) => {
    if (v === null || v === undefined) return false;
    const s = String(v).trim();
    return s !== "" && !Number.isNaN(Number(s));
  };

  const empresaName =
    empresaFilter && !isNumericLike(empresaFilter) ? collapseSpaces(empresaFilter) : null;

  const id_empresa =
    empresaFilter && isNumericLike(empresaFilter) ? Number(empresaFilter) : undefined;

  const date_from =
    dateRange?.[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : undefined;

  const date_to =
    dateRange?.[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : undefined;

  return {
    tipo_conciliacion: tipoConfig.key,

    estado: selectedEstadoId !== ALL ? selectedEstadoId : undefined,
    ciudad: selectedCiudadId !== ALL ? selectedCiudadId : undefined,
    autoridad: selectedAutoridadId !== ALL ? selectedAutoridadId : undefined,

    id_empresa,
    empresa: empresaName || undefined,

    search: term || undefined,

    // ✅ NUEVO: backend
    date_from,
    date_to,
  };
}, [
  selectedEstadoId,
  selectedCiudadId,
  selectedAutoridadId,
  tipoConfig.key,
  empresaFilter,
  searchDebounced,
  dateRange,
]);

// --- deja esto arriba como ya lo tienes ---
const lastFetchKeyRef = useRef("");
const fetchSeqRef = useRef(0);
const tPageRef = useRef(performance.now());

useEffect(() => {
  if (!filtrosBusqueda) return;

  // clave estable: evita re-fetch por renders
  const fetchKey = JSON.stringify(filtrosBusqueda);
  if (lastFetchKeyRef.current === fetchKey) return;
  lastFetchKeyRef.current = fetchKey;

  // (opcional) quita mediciones si no las necesitas
  const t0 = performance.now();

  // Si en el mismo montaje se dispara un fetch más nuevo (p. ej. el filtro
  // "sin ciudad" inicial y luego el ya resuelto con la ciudad por default),
  // la respuesta del más viejo NO debe poder pisar la del más nuevo aunque
  // llegue después. `seq` marca cuál es la petición vigente en cada momento.
  const seq = ++fetchSeqRef.current;
  const isStale = () => fetchSeqRef.current !== seq;

  console.log("[LP] dispatch actionConciliacionGet filtrosBusqueda:", filtrosBusqueda);
const p = dispatch(actionConciliacionGet(filtrosBusqueda, { isStale }));

  Promise.resolve(p)
    .then(() => {
      console.timeEnd("[LP] actionConciliacionGet");
      console.log(
        `[LP] conciliacion resolved in ${(performance.now() - t0).toFixed(0)}ms | since mount ${(performance.now() - tPageRef.current).toFixed(0)}ms`
      );
    })
    .catch(() => {
      console.timeEnd("[LP] actionConciliacionGet");
      console.log(
        `[LP] conciliacion ERROR after ${(performance.now() - t0).toFixed(0)}ms | since mount ${(performance.now() - tPageRef.current).toFixed(0)}ms`
      );
    });
}, [dispatch, filtrosBusqueda]);


  /* =========================
     Empresas distinct (NO Redux): NO TOCADO
     ========================= */
useEffect(() => {
  let isMounted = true;

  const loadEmpresasDistinct = async () => {
    // ✅ si no hay selección real, no pidas distinct
    if (!selectedEstadoId || !selectedCiudadId) {
      if (isMounted) setEmpresasOptionsDistinct([]);
      return;
    }

    // ✅ si está en ALL/ALL, NO tiene sentido pedir distinct (y suele ser query pesada)
    if (selectedEstadoId === ALL || selectedCiudadId === ALL) {
      if (isMounted) setEmpresasOptionsDistinct([]);
      return;
    }

    const resp = await dispatch(
      actionEmpresasdistinct({
        estado: selectedEstadoId,
        ciudad: selectedCiudadId,
        autoridad: selectedAutoridadId !== ALL ? selectedAutoridadId : undefined,
        tipo_conciliacion: tipoConfig.key,
      })
    );

    if (!isMounted) return;

    if (typeof resp === "string") {
      setEmpresasOptionsDistinct([]);
      return;
    }

    const arr = Array.isArray(resp) ? resp : resp?.items || resp?.data || [];
    const options = Array.isArray(arr)
      ? arr
          .map((x) => {
            const label =
              (typeof x === "string" ? x : x?.razon_social || x?.nombre) || "";
            const clean = collapseSpaces(label);
            if (!clean) return null;

            const id =
              typeof x === "object"
                ? x?.id ?? x?.id_empresa ?? x?.empresa_id ?? null
                : null;

            return { label: clean, value: id ?? clean };
          })
          .filter(Boolean)
      : [];

    setEmpresasOptionsDistinct(options);
  };

  loadEmpresasDistinct();

  return () => {
    isMounted = false;
  };
}, [dispatch, selectedEstadoId, selectedCiudadId, selectedAutoridadId, tipoConfig.key]);

const exportCities = useMemo(() => {
  const base = Array.isArray(ciudadesOptions) ? ciudadesOptions : [];
  // ciudadesOptions: [{label, value}]
  return base
    .filter(x => x?.value !== ALL)
    .map(x => ({ id: Number(x.value), name: String(x.label) }));
}, [ciudadesOptions]);


const empresasFinalOptions =
  empresasOptionsDistinct.length > 0 ? empresasOptionsDistinct : empresasOptions;

const exportCompanies = useMemo(() => {
  const base = Array.isArray(empresasFinalOptions) ? empresasFinalOptions : [];
  return base
    .filter(x => x?.value !== ALL && x?.value != null)
    .map(x => ({ id: Number(x.value), name: String(x.label) }));
}, [empresasFinalOptions]);



  /* =========================
     NUEVO: Empresa/Corresponsal (AutoComplete tipo FormDesvinculaciones)
     - sin razón social
     ========================= */
  const [empresaSearchValue, setEmpresaSearchValue] = useState("");
  const [empresaSearchOptions, setEmpresaSearchOptions] = useState([]);
  const [empresaSearching, setEmpresaSearching] = useState(false);
  const empresaSearchTimeoutRef = useRef(null);

  const [empresaDisabledNombre, setEmpresaDisabledNombre] = useState("");
  const [corresponsalDisabledNombre, setCorresponsalDisabledNombre] = useState("");

  const isNumericLike = (v) => {
    if (v === null || v === undefined) return false;
    const s = String(v).trim();
    return s !== "" && !Number.isNaN(Number(s));
  };

  const resetEmpresaSelection = () => {
    setEmpresaFilter(null);
    setEmpresaSearchValue("");
    setEmpresaSearchOptions([]);
    setEmpresaDisabledNombre("");
    setCorresponsalDisabledNombre("");
    setCurrentPage(1);
  };

  const fetchEmpresas = async (q) => {
    const query = (q || "").trim();
    if (!query) return [];

    try {
      setEmpresaSearching(true);
      const { data } = await apiServiceGet.get("empresas/search", {
        params: { q: query, limit: 10 },
        headers: authHeader(),
      });
      return Array.isArray(data) ? data : [];
    } catch (err) {
      console.error("Error /empresas/search:", err?.response?.status || err);
      return [];
    } finally {
      setEmpresaSearching(false);
    }
  };

  const buildEmpresaOptions = (hits) => {
    const opts = [];
    const seen = new Set();
    const MAX = 10;

    for (const it of hits || []) {
      if (opts.length >= MAX) break;

      const empresaNombre = collapseSpaces(pickCompanyName(it) || it?.nombre || "");
      if (!empresaNombre) continue;

      const nCorr = collapseSpaces(
        it?.nombre_corresponsal ||
          it?.corresponsal_nombre ||
          it?.nombre_contacto ||
          it?.contacto_nombre ||
          ""
      );

      const correo = collapseSpaces(it?.correo_corresponsal || it?.corresponsal_correo || it?.email_corresponsal || "");
      const celular = collapseSpaces(it?.celular_corresponsal || it?.corresponsal_celular || it?.telefono_corresponsal || "");

      const key = empresaNombre.toLowerCase() + "|" + (nCorr || "-").toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);

      const empresaId = it?.id_empresa ?? it?.id ?? it?.empresa_id ?? null;

      const optionValue = empresaId != null ? String(empresaId) : empresaNombre;

      opts.push({
        value: optionValue,
        label: (
          <div>
            <div style={{ fontWeight: 600 }}>{empresaNombre}</div>

            <div style={{ fontSize: 12, color: "#6b7280" }}>
              Corresponsal: {nCorr || "—"}
            </div>

            {correo || celular ? (
              <div style={{ fontSize: 12, color: "#9ca3af" }}>
                {correo || ""}
                {correo && celular ? " • " : ""}
                {celular || ""}
              </div>
            ) : null}
          </div>
        ),
        empresa_id: empresaId,
        empresa_nombre: empresaNombre,
        corresponsal_nombre: nCorr || "",
      });
    }

    return opts;
  };

  const handleEmpresaSearch = (value) => {
    setEmpresaSearchValue(value);

    const q = (value || "").trim();
    if (!q) {
      setEmpresaSearchOptions([]);
      setEmpresaDisabledNombre("");
      setCorresponsalDisabledNombre("");
      return;
    }

    if (empresaSearchTimeoutRef.current) clearTimeout(empresaSearchTimeoutRef.current);

    empresaSearchTimeoutRef.current = setTimeout(async () => {
      const hits = await fetchEmpresas(q);
      const opts = buildEmpresaOptions(hits);
      setEmpresaSearchOptions(opts);
    }, 300);
  };

  const handleEmpresaSelect = (value, option) => {
    // value puede ser ID (string num) o nombre
    const v = value || null;

    setEmpresaFilter(v);
    setCurrentPage(1);

    setEmpresaDisabledNombre(option?.empresa_nombre || "");
    setCorresponsalDisabledNombre(option?.corresponsal_nombre || "");

    // en el input mostramos el nombre (no el id)
    setEmpresaSearchValue(option?.empresa_nombre || (isNumericLike(v) ? "" : String(v || "")));
  };

  const handleEmpresaChange = (val) => {
    const v = String(val ?? "");
    setEmpresaSearchValue(v);

    if (!v.trim()) {
      resetEmpresaSelection();
      return;
    }
  };

  // ✅ cuando entra por URL con empresa=id o empresa=nombre, reflejar en el UI (simple)
  useEffect(() => {
    if (empresaFilter == null || empresaFilter === "") {
      setEmpresaSearchValue("");
      setEmpresaDisabledNombre("");
      setCorresponsalDisabledNombre("");
      return;
    }

    // si es nombre, lo pongo directo; si es id, dejo el id como filtro pero el input vacío (hasta que seleccione)
    if (!isNumericLike(empresaFilter)) {
      setEmpresaSearchValue(String(empresaFilter));
      setEmpresaDisabledNombre(String(empresaFilter));
      // corresponsal no lo sabemos aquí
    }
  }, [empresaFilter]);

const {
  statusCounts,
  filteredExpedientes,
  paginatedExpedientes,
  totalExp,
} = useExpedientesProcedimiento({
  concSlice,
  search: searchDebounced,
  statusFilter,

  activosSubFilter,
  conveniosSubFilter,
  concluidosSubFilter,

  fueroFilter,
  empresaFilter,
  dateRange,
  sortOption,
  currentPage,
  pageSize: PAGE_SIZE,
  setCurrentPage,
});


  const goBackToLaboralMenu = () => navigate("/home");

  const handleCrearExpediente = () => {
    if (!selectedEstadoId || !selectedCiudadId || !selectedAutoridadId) {
      notify.warning("Faltan selecciones", "Selecciona Estado, Ciudad y Autoridad antes de crear el expediente.");
      return;
    }

    const nombreIdent = selectedAutoridadData?.nombre_identificacion_ciudad || "";


    navigate(`/materias/laboral/centro-conciliacion/crear`, {
      state: {
        estado: selectedEstadoId,
        ciudad: selectedCiudadId,
        idAutoridad: selectedAutoridadId,
        nombreIdentificacionCiudad: nombreIdent || null,
      },
    });
  };

  const setOrDelete = (sp, key, value) => {
    if (value === null || value === undefined || value === "" || value === "todos") {
      sp.delete(key);
      return;
    }
    sp.set(key, String(value));
  };

  useEffect(() => {
    const sp = new URLSearchParams(searchParams);

    setOrDelete(sp, "estado", selectedEstadoId);
    setOrDelete(sp, "ciudad", selectedCiudadId);
    setOrDelete(sp, "autoridad", selectedAutoridadId);

    // empresa puede ser id o nombre
    setOrDelete(sp, "empresa", empresaFilter);

    // búsqueda
    setOrDelete(sp, "q", collapseSpaces(search));

    // status + substatus
    setOrDelete(sp, "status", statusFilter);
    setOrDelete(sp, "sub", concluidosSubFilter);

    // fechas
    if (dateRange?.[0] && dateRange?.[1]) {
      sp.set("d1", dayjs(dateRange[0]).format("YYYY-MM-DD"));
      sp.set("d2", dayjs(dateRange[1]).format("YYYY-MM-DD"));
    } else {
      sp.delete("d1");
      sp.delete("d2");
    }

    // paginación
    setOrDelete(sp, "page", currentPage);

    const next = sp.toString();
    const prev = searchParams.toString();
    if (next !== prev) setSearchParams(sp, { replace: true });
  }, [
    selectedEstadoId,
    selectedCiudadId,
    selectedAutoridadId,
    empresaFilter,
    search,
    statusFilter,
    concluidosSubFilter,
    dateRange,
    currentPage,
    setSearchParams,
    searchParams,
  ]);

const totalEncontrados = Array.isArray(filteredExpedientes) ? filteredExpedientes.length : 0;
const mapsMemo = useMemo(() => {
  return { ciudadesById, estadosById, statusById };
}, [ciudadesById, estadosById, statusById]);

const formatDateShortEs = (d) => {
  if (!d) return "N/A";
  const x = dayjs(d);
  if (!x.isValid()) return String(d);
  return x.format("DD MMM YYYY HH:mm [hrs]");
};

// Determina qué venció / qué falta en el expediente (espeja isVencidoOrAnomalia del hook).
const computeVencidoInfo = (exp) => {
  const raw =
    Number(exp?.is_constancia_documento) === 1
      ? "cumplimiento_convenio"
      : String(exp?.status_nombre || exp?.status || exp?.estatus || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[̀-ͯ]/g, "")
          .trim();

  // Reglas duras: concluido y cumplimiento nunca son vencidos/anomalía
  if (Number(exp?.is_concluido) === 1) return null;
  if (Number(exp?.is_constancia_documento) === 1) return null;
  if (raw.includes("cumplimiento_convenio")) return null;

  const isPast = (v) => {
    const d = dayjs(v);
    return d.isValid() && d.isBefore(dayjs(), "day");
  };
  // Para audiencias con hora: si ya pasó la fecha Y hora exacta (aunque sea el mismo día), cuenta como vencida.
  const isPastExact = (v) => {
    const d = dayjs(v);
    return d.isValid() && d.isBefore(dayjs());
  };
  const daysPast = (v) => {
    const d = dayjs(v);
    if (!d.isValid()) return 0;
    const diff = dayjs().startOf("day").diff(d.startOf("day"), "day");
    return diff > 0 ? diff : 0;
  };
  const hace = (v) => {
    const n = daysPast(v);
    return n > 0 ? ` · hace ${n} día${n === 1 ? "" : "s"}` : "";
  };

  // 1) Cumplimiento (status 7) sin fecha de convenio
  if (Number(exp?.id_conciliacion_status) === 7 && !exp?.fecha_convenio) {
    return { tipo: "falta", texto: "Falta registrar la fecha de convenio" };
  }

  // 2) Convenio: falta próximo pago / pago vencido
  if (raw.includes("convenio")) {
    if (!exp?.fecha_proximo_pago) {
      return { tipo: "falta", texto: "Falta fecha de próximo pago" };
    }
    if (isPast(exp?.fecha_proximo_pago)) {
      return {
        tipo: "vencido",
        texto: `Pago vencido: ${formatDateShortEs(exp.fecha_proximo_pago)}${hace(exp.fecha_proximo_pago)}`,
      };
    }
  }

  // 3) Activo / Diferido: falta audiencia / audiencia vencida
  if (raw.includes("activo") || raw.includes("difer")) {
    if (!exp?.fecha_proxima_audiencia) {
      return { tipo: "falta", texto: "Falta fecha de próxima audiencia" };
    }
    if (isPastExact(exp?.fecha_proxima_audiencia)) {
      return {
        tipo: "vencido",
        texto: `Hace falta actualizar el resultado de la audiencia: ${formatDateShortEs(exp.fecha_proxima_audiencia)}${hace(exp.fecha_proxima_audiencia)}`,
      };
    }
  }

  return null;
};

const mapConciliacionToRow = (exp) => {
  const id = exp?.id_conciliacion ?? exp?.id;
  const actorName = Array.isArray(exp?.trabajadores)
    ? exp.trabajadores.map((t) => t?.nombre_trabajador).filter(Boolean).join(", ")
    : "";
  const razones = Array.isArray(exp?.razones_sociales)
    ? exp.razones_sociales.map((x) => (x?.razon_social || "").replace(/\s+/g, " ").trim()).filter(Boolean)
    : [];
  const contraName = razones.length > 0 ? razones.join(" / ") : (exp?.nombre_empresa || "");
  const caseTitle = [actorName || "—", contraName].filter(Boolean).join(" vs ");
  const accion = exp?.tipo_objeto || exp?.objeto || "";
  const objetoSolicitud = exp?.nombre_objeto || exp?.objeto_solicitud || accion || "";
  const rawStatus = String(exp?.status || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").trim();
  const isConstanciaConcl = Number(exp?.is_constancia_documento) === 1;
  const numAudienciasTotal = Number(
    exp?.total_audiencias_prejudiciales ?? exp?.audiencias_count ?? exp?.num_audiencias ?? exp?.total_audiencias ?? exp?.audiencia_count ?? exp?.cantidad_audiencias ?? 0
  );
  // total_audiencias_prejudiciales cuenta las audiencias YA CELEBRADAS: en la que
  // se llegó a convenio/cumplimiento cuenta como celebrada, así que el número ES el ordinal.
  const audienciaOrigenLabel =
    numAudienciasTotal >= 3 ? "3ra audiencia" : numAudienciasTotal === 2 ? "2da audiencia" : "1ra audiencia";

  let estatus;
  let estatusAudienciaOrigen = null;
  if (isConstanciaConcl || rawStatus.includes("cumpl")) {
    estatus = { label: "CUMPLIMIENTO", kind: "green", icon: "bi-check2-circle" };
    estatusAudienciaOrigen = audienciaOrigenLabel;
  } else if (!isConstanciaConcl && rawStatus.includes("convenio")) {
    estatus = { label: "CONVENIO", kind: "red", icon: "bi-file-earmark-text" };
    estatusAudienciaOrigen = audienciaOrigenLabel;
  } else if (rawStatus.includes("activo")) {
    estatus = { label: "1ERA AUDIENCIA", kind: "blue", icon: "bi-check-circle" };
  } else if (rawStatus.includes("difer")) {
    const audNum = numAudienciasTotal >= 2 ? 3 : 2;
    estatus = { label: `AUDIENCIA #${audNum}`, kind: "yellow", icon: "bi-clock" };
  } else if (rawStatus.includes("no conciliac") || rawStatus.includes("no_conciliac")) {
    estatus = { label: "NO CONCILIACIÓN", kind: "black", icon: "bi-slash-circle" };
  } else if (rawStatus.includes("incompar") || rawStatus.includes("archivo")) {
    const quien = rawStatus.includes("patron")
      ? "Patrón"
      : (rawStatus.includes("trabajad") ? "Trabajador" : "");
    estatus = {
      label: quien ? `ARCHIVO · ${quien.toUpperCase()}` : "ARCHIVO",
      kind: "black",
      icon: "bi-archive",
    };
  } else if (rawStatus.includes("conclu")) {
    estatus = { label: "CONCLUIDO", kind: "gray", icon: "bi-stop-circle" };
  } else {
    estatus = { label: (rawStatus.toUpperCase() || "SIN ESTADO"), kind: "gray", icon: "bi-question-circle" };
  }
  const autoridad = exp?.nombre_autoridad || "";
  const ubicacion = `${exp?.nombre_estado || ""}${exp?.nombre_estado && exp?.nombre_ciudad ? " / " : ""}${exp?.nombre_ciudad || ""}`.trim();
  const expediente = exp?.num_unico || exp?.expediente_format || String(id || "");
  let eventoFecha = "N/A", eventoTipo = "Sin fecha", eventoKind = "gray", eventoIcon = "schedule";
  let eventoFechaRaw = null;
  if (exp?.fecha_proxima_audiencia) {
    eventoFecha = formatDateShortEs(exp.fecha_proxima_audiencia);
    eventoTipo = "Próx. audiencia";
    eventoKind = "yellow";
    eventoIcon = "event";
    eventoFechaRaw = exp.fecha_proxima_audiencia;
  } else if (exp?.fecha_audiencia_inicial) {
    eventoFecha = formatDateShortEs(exp.fecha_audiencia_inicial);
    eventoTipo = "Audiencia inicial";
    eventoKind = "blue";
    eventoIcon = "event_available";
    eventoFechaRaw = exp.fecha_audiencia_inicial;
  }

  // ¿Qué venció / qué falta? (misma lógica que isVencidoOrAnomalia del hook)
  const vencido = computeVencidoInfo(exp);

  return {
    id: Number.isFinite(Number(id)) ? Number(id) : null,
    expediente,
    actor: actorName || "—",
    contraparte: contraName || "—",
    caseTitle,
    accion,
    objetoSolicitud: objetoSolicitud || "—",
    estatus,
    estatusAudienciaOrigen,
    autoridad: autoridad || "—",
    ubicacion: ubicacion || "—",
    eventoFecha, eventoTipo, eventoKind, eventoIcon, eventoFechaRaw,
    vencido,
  };
};

const rows = useMemo(() => (paginatedExpedientes || []).map(mapConciliacionToRow), [paginatedExpedientes]);
const rowsPerPage = PAGE_SIZE || 20;
const totalPages = Math.max(1, Math.ceil(totalEncontrados / rowsPerPage));

function TableView({ pageRows, total, totalPages, page, setPage }) {
  const columns = [
    {
      title: "Expediente / Actor",
      key: "expediente",
      width: 260,
      render: (_, r) => (
        <>
          <div className="fw-semibold">{r.expediente}</div>
          <div className="small fw-semibold text-uppercase">{r.caseTitle}</div>
        </>
      ),
    },
    {
      title: "Estatus",
      key: "accion",
      render: (_, r) => (
        <>
          {r.accion && <div className="small mb-1">{r.accion}</div>}
          <StatusPillConc kind={r.estatus.kind} icon={r.estatus.icon} label={r.estatus.label} />
          {r.estatusAudienciaOrigen && (
            <div
              className="small fw-semibold mt-1"
              style={{ color: STATUS_PILL_HEX[r.estatus.kind] || undefined }}
            >
              {r.estatusAudienciaOrigen}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Autoridad",
      key: "autoridad",
      render: (_, r) => (
        <>
          <div className="small" title={r.autoridad}>{r.autoridad}</div>
          <div className="small text-secondary">
            <i className="bi bi-geo-alt-fill me-1" />
            {r.ubicacion}
          </div>
        </>
      ),
    },
    {
      title: "Próxima audiencia",
      key: "evento",
      render: (_, r) => (
        <div
          className={`exp-audiencia-highlight exp-audiencia-highlight--${r.vencido ? "secondary" : eventoBsColor(r.eventoKind)}${
            isAudienciaEstaSemana(r.eventoFechaRaw) && !r.vencido ? " exp-audiencia-highlight--soon" : ""
          }`}
        >
          <div className="exp-audiencia-highlight-icon-wrap">
            <svg
              className="exp-audiencia-highlight-icon"
              viewBox="0 0 448 512"
              width="17"
              height="17"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM80 256C71.16 256 64 263.2 64 272V368C64 376.8 71.16 384 80 384H176C184.8 384 192 376.8 192 368V272C192 263.2 184.8 256 176 256H80z" />
            </svg>
          </div>
          <div className="exp-audiencia-highlight-body">
            <div className="exp-audiencia-highlight-label">
              {r.vencido ? "Audiencia celebrada" : "Próxima audiencia"}
            </div>
            <div className="exp-audiencia-highlight-value">{r.eventoFecha}</div>
            <div className="exp-audiencia-highlight-sub">{r.eventoTipo}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Acciones",
      key: "acciones",
      align: "right",
      render: (_, r) => (
        <Button
          type="primary"
          block
          onClick={() => canConsultar && navigate(`/materias/laboral/centro-conciliacion/${r.id}${location.search}`)}
          disabled={!canConsultar}
          title={!canConsultar ? "Sin permiso de consulta" : undefined}
        >
          <svg className="me-1" viewBox="0 0 512 512" width="13" height="13" fill="currentColor" aria-hidden="true" style={{ verticalAlign: "-1px" }}>
            <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z" />
          </svg>
          Ver detalles
        </Button>
      ),
    },
  ];

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <Table
        columns={columns}
        dataSource={pageRows}
        rowKey={(r) => r.expediente + r.id}
        pagination={false}
      />
      <div className="p-3" style={{ borderTop: "1px solid #eef2f7", background: "#fff" }}>
        <FooterPagerConc total={total} totalPages={totalPages} page={page} setPage={setPage} />
      </div>
    </Card>
  );
}

function CardsView({ rows, total, totalPages, page, setPage }) {
  return (
    <>
      <Row gutter={[24, 24]}>
        {rows.map((r) => (
          <Col key={r.expediente + r.id} xs={24} md={12} xl={8} xxl={6}>
            <Card className="h-100 exp-card" bodyStyle={{ display: "flex", flexDirection: "column", gap: 8, height: "100%" }}>
              <div className="d-flex align-items-start justify-content-between gap-2">
                <div className="fw-semibold text-uppercase">{r.caseTitle}</div>
                <div className="d-flex flex-column align-items-end gap-1">
                  <StatusPillConc kind={r.estatus.kind} icon={r.estatus.icon} label={r.estatus.label} />
                  {r.estatusAudienciaOrigen && (
                    <div
                      className="small fw-semibold"
                      style={{ color: STATUS_PILL_HEX[r.estatus.kind] || undefined }}
                    >
                      {r.estatusAudienciaOrigen}
                    </div>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-start gap-2 small">
                <svg
                  className="mt-1"
                  viewBox="0 0 384 512"
                  width="14"
                  height="14"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M256 0v128h128L256 0zM224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM272 416h-160C103.2 416 96 408.8 96 400C96 391.2 103.2 384 112 384h160c8.836 0 16 7.162 16 16C288 408.8 280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336C96 327.2 103.2 320 112 320h160c8.836 0 16 7.162 16 16C288 344.8 280.8 352 272 352zM288 272C288 280.8 280.8 288 272 288h-160C103.2 288 96 280.8 96 272C96 263.2 103.2 256 112 256h160C280.8 256 288 263.2 288 272z" />
                </svg>
                <div>
                  <div className="text-secondary text-uppercase" style={{ fontSize: 11 }}>
                    Objeto de la solicitud
                  </div>
                  <div>{r.objetoSolicitud}</div>
                </div>
              </div>

              <hr className="my-1" />

              <div className="d-flex flex-column gap-1 small text-secondary">
                <div>
                  <svg
                    className="me-1"
                    viewBox="0 0 512 512"
                    width="13"
                    height="13"
                    fill="currentColor"
                    aria-hidden="true"
                    style={{ verticalAlign: "-1px" }}
                  >
                    <path d="M240.1 4.216C249.1-1.405 262-1.405 271.9 4.216L443.6 102.4L447.1 104V104.9L495.9 132.2C508.5 139.4 514.6 154.2 510.9 168.2C507.2 182.2 494.5 192 479.1 192H31.1C17.49 192 4.795 182.2 1.071 168.2C-2.653 154.2 3.524 139.4 16.12 132.2L63.1 104.9V104L68.37 102.4L240.1 4.216zM64 224H128V416H168V224H232V416H280V224H344V416H384V224H448V420.3C448.6 420.6 449.2 420.1 449.8 421.4L497.8 453.4C509.5 461.2 514.7 475.8 510.6 489.3C506.5 502.8 494.1 512 480 512H32C17.9 512 5.46 502.8 1.373 489.3C-2.713 475.8 2.517 461.2 14.25 453.4L62.25 421.4C62.82 420.1 63.41 420.6 64 420.3V224z" />
                  </svg>
                  {r.autoridad}
                </div>
                <div>
                  <svg
                    className="me-1"
                    viewBox="0 0 384 512"
                    width="13"
                    height="13"
                    fill="currentColor"
                    aria-hidden="true"
                    style={{ verticalAlign: "-1px" }}
                  >
                    <path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" />
                  </svg>
                  {r.ubicacion}
                </div>
                <div>
                  <i className="bi bi-hash me-1" />
                  Expediente: <strong>{r.expediente}</strong>
                </div>
              </div>

              <div className="mt-auto">
                <div
                  className={`exp-audiencia-highlight exp-audiencia-highlight--${r.vencido ? "secondary" : eventoBsColor(r.eventoKind)} mb-2${
                    isAudienciaEstaSemana(r.eventoFechaRaw) && !r.vencido ? " exp-audiencia-highlight--soon" : ""
                  }`}
                >
                  <div className="exp-audiencia-highlight-icon-wrap">
                    <svg
                      className="exp-audiencia-highlight-icon"
                      viewBox="0 0 448 512"
                      width="17"
                      height="17"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM80 256C71.16 256 64 263.2 64 272V368C64 376.8 71.16 384 80 384H176C184.8 384 192 376.8 192 368V272C192 263.2 184.8 256 176 256H80z" />
                    </svg>
                  </div>
                  <div className="exp-audiencia-highlight-body">
                    <div className="exp-audiencia-highlight-label">
                      {r.vencido ? "Audiencia celebrada" : "Próxima audiencia"}
                    </div>
                    <div className="exp-audiencia-highlight-value">{r.eventoFecha}</div>
                    <div className="exp-audiencia-highlight-sub">{r.eventoTipo}</div>
                  </div>
                </div>

                {r.vencido && (
                  <Alert
                    type={r.vencido.tipo === "vencido" ? "error" : "warning"}
                    showIcon={false}
                    className="mb-2 small"
                    message={
                      <span className="d-flex align-items-center gap-2">
                        <i className={`bi ${r.vencido.tipo === "vencido" ? "bi-exclamation-circle" : "bi-exclamation-triangle"}`} />
                        {r.vencido.texto}
                      </span>
                    }
                  />
                )}

                <Button
                  type="primary"
                  block
                  onClick={() => canConsultar && navigate(`/materias/laboral/centro-conciliacion/${r.id}${location.search}`)}
                  disabled={!canConsultar}
                  title={!canConsultar ? "Sin permiso de consulta" : undefined}
                >
                  <svg className="me-1" viewBox="0 0 512 512" width="13" height="13" fill="currentColor" aria-hidden="true" style={{ verticalAlign: "-1px" }}>
                    <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z" />
                  </svg>
                  Ver detalles
                </Button>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      <div className="mt-3">
        <FooterPagerConc total={total} totalPages={totalPages} page={page} setPage={setPage} />
      </div>
    </>
  );
}

const EXPORT_MENU_TONES = {
  primary: { bg: "#DCE9F5", fg: "#0A539A" },
  teal: { bg: "#E6F6F9", fg: "#3A94A8" },
  green: { bg: "#DCFCE7", fg: "#16A34A" },
};

function ExportMenuRow({ viewBox, path, tone, title, subtitle }) {
  const colors = EXPORT_MENU_TONES[tone] || EXPORT_MENU_TONES.primary;
  const [, , vbW, vbH] = viewBox.split(" ").map(Number);
  const height = 16;
  const width = Math.round((vbW / vbH) * height);
  return (
    <div className="laboral-export-menu-row">
      <span
        className="laboral-export-menu-icon"
        style={{ background: colors.bg, color: colors.fg }}
      >
        <svg viewBox={viewBox} width={width} height={height} fill="currentColor" aria-hidden="true">
          <path d={path} />
        </svg>
      </span>
      <div className="laboral-export-menu-text">
        <div className="laboral-export-menu-title">{title}</div>
        <div className="laboral-export-menu-subtitle">{subtitle}</div>
      </div>
    </div>
  );
}

function eventoBsColor(kind) {
  const map = { yellow: "warning", blue: "info", green: "success", red: "danger", gray: "secondary" };
  return map[kind] || "secondary";
}

function isAudienciaEstaSemana(fechaRaw) {
  if (!fechaRaw) return false;
  const d = dayjs(fechaRaw);
  if (!d.isValid()) return false;
  if (d.isBefore(dayjs(), "day")) return false;
  return d.isSame(dayjs(), "week");
}

function FooterPagerConc({ total, totalPages, page, setPage }) {
  const ps = PAGE_SIZE || 20;
  const start = total === 0 ? 0 : (page - 1) * ps + 1;
  const end = Math.min(page * ps, total);
  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <small className="text-secondary">
        Mostrando <strong>{start}</strong> a <strong>{end}</strong> de <strong>{total}</strong> resultados
      </small>
      <AppPagination current={page} total={total} pageSize={ps} onChange={setPage} size="sm" />
    </div>
  );
}

  return (
    <ConfigProvider locale={esES} wave={{ showEffect: showInsetEffect }}>
    <div>
      <main className="trib-main">
        <Modal
          open={exportPreviewOpen}
          onCancel={() => setExportPreviewOpen(false)}
          centered
          width={1140}
          title="Previsualización"
          footer={[
            <Button key="close" onClick={() => setExportPreviewOpen(false)}>
              Cerrar
            </Button>,
            <Button
              key="export"
              type="primary"
              onClick={() => {
                const list = Array.isArray(filteredExpedientes) ? filteredExpedientes : [];

                const now = new Date();
                const y = now.getFullYear();

                const periodFrom = dateRange?.[0]
                  ? dayjs(dateRange[0]).format("YYYY-MM-DD")
                  : `${y}-01-01`;

                const periodTo = dateRange?.[1]
                  ? dayjs(dateRange[1]).format("YYYY-MM-DD")
                  : `${y}-12-31`;

                const ciudadesLabel =
                  selectedCiudadId === ALL ? "Todas" : (ciudadSeleccionada?.nombre || "—");

                const nombreEmpresa = collapseSpaces(search) || "Todas";

                printLaboralReportPdf({
                  items: list,
                  periodFrom,
                  periodTo,
                  ciudadesLabel,
                  nombreEmpresa,
                });
              }}
            >
              Exportar PDF
            </Button>,
          ]}
        >
          <div style={{ height: "72vh", border: "1px solid #e5e7eb", overflow: "hidden" }}>
            <iframe
              title="preview"
              style={{ width: "100%", height: "100%", border: 0, background: "#fff" }}
              srcDoc={exportPreviewHtml}
            />
          </div>
        </Modal>
        <div className="trib-wrap">
          {/* PANEL FILTROS */}
<div className="laboral-filters-panel">
  <div className="laboral-panel-header">
    <h1 className="laboral-panel-title">{tipoConfig.title} · Materia laboral</h1>
    {estadoSeleccionado && ciudadSeleccionada ? (
      <p className="laboral-panel-subtitle">
        Expedientes de {tipoConfig.shortLabel.toLowerCase()} en <b>{estadoSeleccionado.nombre}</b> /{" "}
        <b>{ciudadSeleccionada.nombre}</b>.
      </p>
    ) : (
      <p className="laboral-panel-subtitle">
        Selecciona un estado y una ciudad para ver los expedientes.
      </p>
    )}
  </div>

  {/* Fila 1: Estado / Ciudad / Autoridad */}
  <div className="laboral-filter-row-1">
    <div className="laboral-field">
      <div className="laboral-field-label">ESTADO</div>
      <Select
        className="laboral-control"
        value={selectedEstadoId}
        options={estadosOptionsFinal}
        onChange={(value) => handleChangeEstado(value)}
        showSearch
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
      />
    </div>

    <div className="laboral-field">
      <div className="laboral-field-label">CIUDAD</div>
      <Select
        className="laboral-control"
        value={selectedCiudadId}
        options={ciudadesOptionsFinal}
        onChange={(value) => handleChangeCiudad(value)}
        showSearch
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
      />
    </div>

    <div className="laboral-field">
      <div className="laboral-field-label">AUTORIDAD</div>
      <Select
        className="laboral-control"
        value={selectedAutoridadId}
        options={autoridadOptions}
        showSearch
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        onChange={(value, option) => {
          setSelectedAutoridadId(value ?? ALL);
          setSelectedAutoridadData(option?.data || null);
          setCurrentPage(1);
        }}
      />
    </div>
  </div>

  {/* Fila 2: Buscador (izq, ancho) + Fecha (centro, fija) + Botones (der) */}
  <div className="laboral-filter-row-2">
    {/* Buscador ancho */}
    <div className="laboral-field laboral-field--search">
      <div className="laboral-field-label">BUSCADOR</div>
      <Input
        className="laboral-search-modern__input"
        prefix={<SearchOutlined className="laboral-search-modern__icon" />}
        value={search}
        onChange={(e) => {
          const v = e.target.value;
          setSearch(v); // ✅ solo buscador general
          setCurrentPage(1);
        }}
        placeholder="Buscar por expediente, empresa o corresponsal..."
      />
    </div>

    {/* Fecha fija tipo "Inicio - Fin" */}
    <div className="laboral-field laboral-field--dates">
      <div className="laboral-field-label">FECHA DE AUDIENCIA</div>
      <div className="laboral-date-range">
        <ScrollDatePicker
          value={dateRange?.[0] ? dayjs(dateRange[0]) : null}
          format="YYYY-MM-DD"
          placeholder="Inicio"
          allowClear
          onChange={(d) => {
            setDateRange((prev) => [d ? d.toDate() : null, prev?.[1] ?? null]);
            setCurrentPage(1);
          }}
        />
        <span className="laboral-date-range-sep">–</span>
        <ScrollDatePicker
          value={dateRange?.[1] ? dayjs(dateRange[1]) : null}
          format="YYYY-MM-DD"
          placeholder="Fin"
          allowClear
          onChange={(d) => {
            setDateRange((prev) => [prev?.[0] ?? null, d ? d.toDate() : null]);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>

    {/* Botones */}
    <div className="laboral-field laboral-field--actions">
      <div className="laboral-field-label">&nbsp;</div>

      <div className="laboral-actions">
        <Button
          onClick={() => {
            resetEmpresaSelection();
            setSearch("");
            setDateRange(null);
            setStatusFilter("todos");
            setConcluidosSubFilter("todos");
            setCurrentPage(1);
          }}
          className="laboral-btn-clean"
        >
          Limpiar
        </Button>
        {canInsertar && (
        <HappyProvider>
          <Button
            type="primary"
            onClick={handleCrearExpediente}
            disabled={!selectedAutoridadId}
            className="laboral-btn-create"
            icon={
              <svg viewBox="0 0 448 512" width="13" height="13" fill="currentColor" aria-hidden="true">
                <path d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z" />
              </svg>
            }
          >
            Crear
          </Button>
        </HappyProvider>
        )}
      </div>
    </div>
  </div>
</div>


            {/* KPI cards */}
            <Row gutter={[16, 16]}>
              <Col xs={24} md={8}>
                <KpiCardConc
                  iconBg="primary"
                  iconSvg={
                    <svg viewBox="0 0 576 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                      <path d="M147.8 192H480V144C480 117.5 458.5 96 432 96h-160l-64-64h-160C21.49 32 0 53.49 0 80v328.4l90.54-181.1C101.4 205.6 123.4 192 147.8 192zM543.1 224H147.8C135.7 224 124.6 230.8 119.2 241.7L0 480h447.1c12.12 0 23.2-6.852 28.62-17.69l96-192C583.2 249 567.7 224 543.1 224z" />
                    </svg>
                  }
                  value={String(statusCounts?.activos ?? 0)}
                  label="Activos"
                  active={statusFilter === "activos"}
                  onClick={() => {
                    setStatusFilter((prev) => (prev === "activos" ? "todos" : "activos"));
                    setActivosSubFilter("todos");
                    setConveniosSubFilter("todos");
                    setConcluidosSubFilter("todos");
                    setCurrentPage(1);
                  }}
                />
              </Col>
              <Col xs={24} md={8}>
                <KpiCardConc
                  iconBg="red"
                  iconSvg={
                    <svg viewBox="0 0 640 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                      <path d="M488 191.1h-152l.0001 51.86c.0001 37.66-27.08 72-64.55 75.77c-43.09 4.333-79.45-29.42-79.45-71.63V126.4l-24.51 14.73C123.2 167.8 96.04 215.7 96.04 267.5L16.04 313.8c-15.25 8.751-20.63 28.38-11.75 43.63l80 138.6c8.875 15.25 28.5 20.5 43.75 11.75l103.4-59.75h136.6c35.25 0 64-28.75 64-64c26.51 0 48-21.49 48-48V288h8c13.25 0 24-10.75 24-24l.0001-48C512 202.7 501.3 191.1 488 191.1zM635.7 154.5l-79.95-138.6c-8.875-15.25-28.5-20.5-43.75-11.75l-103.4 59.75h-62.57c-37.85 0-74.93 10.61-107.1 30.63C229.7 100.4 224 110.6 224 121.6l-.0004 126.4c0 22.13 17.88 40 40 40c22.13 0 40-17.88 40-40V159.1h184c30.93 0 56 25.07 56 56v28.5l80-46.25C639.3 189.4 644.5 169.8 635.7 154.5z" />
                    </svg>
                  }
                  value={String(statusCounts?.convenios ?? 0)}
                  label="Convenios"
                  active={statusFilter === "convenios"}
                  onClick={() => {
                    const next = statusFilter === "convenios" ? "todos" : "convenios";
                    setStatusFilter(next);
                    setActivosSubFilter("todos");
                    setConcluidosSubFilter("todos");
                    setConveniosSubFilter("todos");
                    setCurrentPage(1);
                  }}
                />
              </Col>
              <Col xs={24} md={8}>
                <KpiCardConc
                  iconBg="gray"
                  iconSvg={
                    <svg viewBox="0 0 512 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                      <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z" />
                    </svg>
                  }
                  value={String(statusCounts?.concluidos ?? 0)}
                  label="Concluidos"
                  active={statusFilter === "concluidos"}
                  onClick={() => {
                    setStatusFilter((prev) => (prev === "concluidos" ? "todos" : "concluidos"));
                    setActivosSubFilter("todos");
                    setConveniosSubFilter("todos");
                    setConcluidosSubFilter("todos");
                    setCurrentPage(1);
                  }}
                />
              </Col>
            </Row>
{/* Subfiltros de Activos */}
<div className={`laboral-substats-wrap ${statusFilter === "activos" ? "is-open" : ""}`}>
  <div className="laboral-stats-row laboral-substats-row laboral-substats-row--4">
    <Card
      className={`laboral-stat-card ${activosSubFilter === "primera" ? "laboral-stat-active" : ""}`}
      bodyStyle={{ padding: 0 }}
      onClick={() => {
        setActivosSubFilter((prev) => (prev === "primera" ? "todos" : "primera"));
        setCurrentPage(1);
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="laboral-stat-icon" style={{ color: "#1677ff", background: "#e6f4ff", fontSize: 13, fontWeight: 700 }}>
          1ra
        </div>
        <div>
          <div className="laboral-stat-value">{statusCounts?.activosPrimera ?? 0}</div>
          <div className="laboral-stat-label">Primera audiencia</div>
        </div>
      </div>
    </Card>

    <Card
      className={`laboral-stat-card ${activosSubFilter === "segunda" ? "laboral-stat-active" : ""}`}
      bodyStyle={{ padding: 0 }}
      onClick={() => {
        setActivosSubFilter((prev) => (prev === "segunda" ? "todos" : "segunda"));
        setCurrentPage(1);
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="laboral-stat-icon" style={{ color: "#d4a017", background: "#fefce8", fontSize: 13, fontWeight: 700 }}>
          2da
        </div>
        <div>
          <div className="laboral-stat-value">{statusCounts?.activosSegunda ?? 0}</div>
          <div className="laboral-stat-label">Segunda audiencia</div>
        </div>
      </div>
    </Card>

    <Card
      className={`laboral-stat-card ${activosSubFilter === "tercera" ? "laboral-stat-active" : ""}`}
      bodyStyle={{ padding: 0 }}
      onClick={() => {
        setActivosSubFilter((prev) => (prev === "tercera" ? "todos" : "tercera"));
        setCurrentPage(1);
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="laboral-stat-icon" style={{ color: "#c2410c", background: "#fff7ed", fontSize: 13, fontWeight: 700 }}>
          3ra
        </div>
        <div>
          <div className="laboral-stat-value">{statusCounts?.activosTercera ?? 0}</div>
          <div className="laboral-stat-label">Tercera audiencia</div>
        </div>
      </div>
    </Card>

    <Card
      className={`laboral-stat-card ${activosSubFilter === "todos" ? "laboral-stat-active" : ""}`}
      bodyStyle={{ padding: 0 }}
      onClick={() => {
        setActivosSubFilter("todos");
        setCurrentPage(1);
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="laboral-stat-icon">
          <svg viewBox="0 0 512 512" width="16" height="16" fill="currentColor" aria-hidden="true">
            <path d="M232.5 5.171C247.4-1.718 264.6-1.718 279.5 5.171L498.1 106.2C506.6 110.1 512 118.6 512 127.1C512 137.3 506.6 145.8 498.1 149.8L279.5 250.8C264.6 257.7 247.4 257.7 232.5 250.8L13.93 149.8C5.438 145.8 0 137.3 0 127.1C0 118.6 5.437 110.1 13.93 106.2L232.5 5.171zM498.1 234.2C506.6 238.1 512 246.6 512 255.1C512 265.3 506.6 273.8 498.1 277.8L279.5 378.8C264.6 385.7 247.4 385.7 232.5 378.8L13.93 277.8C5.438 273.8 0 265.3 0 255.1C0 246.6 5.437 238.1 13.93 234.2L67.13 209.6L219.1 279.8C242.5 290.7 269.5 290.7 292.9 279.8L444.9 209.6L498.1 234.2zM292.9 407.8L444.9 337.6L498.1 362.2C506.6 366.1 512 374.6 512 383.1C512 393.3 506.6 401.8 498.1 405.8L279.5 506.8C264.6 513.7 247.4 513.7 232.5 506.8L13.93 405.8C5.438 401.8 0 393.3 0 383.1C0 374.6 5.437 366.1 13.93 362.2L67.13 337.6L219.1 407.8C242.5 418.7 269.5 418.7 292.9 407.8V407.8z" />
          </svg>
        </div>
        <div>
          <div className="laboral-stat-value">{statusCounts?.activos ?? 0}</div>
          <div className="laboral-stat-label">Todo</div>
        </div>
      </div>
    </Card>
  </div>
</div>
{/* Subfiltros de Convenios */}
<div className={`laboral-substats-wrap ${statusFilter === "convenios" ? "is-open" : ""}`}>
  <div className="laboral-stats-row laboral-substats-row">

    <Card
      className={`laboral-stat-card ${conveniosSubFilter === "convenio" ? "laboral-stat-active" : ""}`}
      bodyStyle={{ padding: 0 }}
      onClick={() => {
        setConveniosSubFilter((prev) => (prev === "convenio" ? "todos" : "convenio"));
        setCurrentPage(1);
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="laboral-stat-icon" style={{ color: "#DC2626", background: "#FEE2E2" }}>
          <svg viewBox="0 0 640 512" width="22" height="22" fill="currentColor" aria-hidden="true">
            <path d="M0 383.9l64 .0404c17.75 0 32-14.29 32-32.03V128.3L0 128.3V383.9zM48 320.1c8.75 0 16 7.118 16 15.99c0 8.742-7.25 15.99-16 15.99S32 344.8 32 336.1C32 327.2 39.25 320.1 48 320.1zM348.8 64c-7.941 0-15.66 2.969-21.52 8.328L228.9 162.3C228.8 162.5 228.8 162.7 228.6 162.7C212 178.3 212.3 203.2 226.5 218.7c12.75 13.1 39.38 17.62 56.13 2.75C282.8 221.3 282.9 221.3 283 221.2l79.88-73.1c6.5-5.871 16.75-5.496 22.62 1c6 6.496 5.5 16.62-1 22.62l-26.12 23.87L504 313.7c2.875 2.496 5.5 4.996 7.875 7.742V127.1c-40.98-40.96-96.48-63.88-154.4-63.88L348.8 64zM334.6 217.4l-30 27.49c-29.75 27.11-75.25 24.49-101.8-4.371C176 211.2 178.1 165.7 207.3 138.9L289.1 64H282.5C224.7 64 169.1 87.08 128.2 127.9L128 351.8l18.25 .0369l90.5 81.82c27.5 22.37 67.75 18.12 90-9.246l18.12 15.24c15.88 12.1 39.38 10.5 52.38-5.371l31.38-38.6l5.374 4.498c13.75 11 33.88 9.002 45-4.748l9.538-11.78c11.12-13.75 9.036-33.78-4.694-44.93L334.6 217.4zM544 128.4v223.6c0 17.62 14.25 32.05 31.1 32.05L640 384V128.1L544 128.4zM592 352c-8.75 0-16-7.246-16-15.99c0-8.875 7.25-15.99 16-15.99S608 327.2 608 336.1C608 344.8 600.8 352 592 352z" />
          </svg>
        </div>
        <div>
          <div className="laboral-stat-value">{statusCounts?.conveniosOnly ?? 0}</div>
          <div className="laboral-stat-label">Convenios</div>
        </div>
      </div>
    </Card>

    <Card
      className={`laboral-stat-card ${conveniosSubFilter === "constancia" ? "laboral-stat-active" : ""}`}
      bodyStyle={{ padding: 0 }}
      onClick={() => {
        setConveniosSubFilter((prev) => (prev === "constancia" ? "todos" : "constancia"));
        setCurrentPage(1);
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="laboral-stat-icon" style={{ color: "#16a34a", background: "#f0fdf4" }}>
          <svg viewBox="0 0 576 512" width="16" height="16" fill="currentColor" aria-hidden="true">
            <path d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V198.6C310.1 219.5 256 287.4 256 368C256 427.1 285.1 479.3 329.7 511.3C326.6 511.7 323.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256zM576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368zM476.7 324.7L416 385.4L387.3 356.7C381.1 350.4 370.9 350.4 364.7 356.7C358.4 362.9 358.4 373.1 364.7 379.3L404.7 419.3C410.9 425.6 421.1 425.6 427.3 419.3L499.3 347.3C505.6 341.1 505.6 330.9 499.3 324.7C493.1 318.4 482.9 318.4 476.7 324.7H476.7z" />
          </svg>
        </div>
        <div>
          <div className="laboral-stat-value">{statusCounts?.constanciasOnly ?? 0}</div>
          <div className="laboral-stat-label">Cumplimientos</div>
        </div>
      </div>
    </Card>

    <Card
      className={`laboral-stat-card ${conveniosSubFilter === "todos" ? "laboral-stat-active" : ""}`}
      bodyStyle={{ padding: 0 }}
      onClick={() => {
        setConveniosSubFilter("todos");
        setCurrentPage(1);
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="laboral-stat-icon">
          <svg viewBox="0 0 512 512" width="16" height="16" fill="currentColor" aria-hidden="true">
            <path d="M232.5 5.171C247.4-1.718 264.6-1.718 279.5 5.171L498.1 106.2C506.6 110.1 512 118.6 512 127.1C512 137.3 506.6 145.8 498.1 149.8L279.5 250.8C264.6 257.7 247.4 257.7 232.5 250.8L13.93 149.8C5.438 145.8 0 137.3 0 127.1C0 118.6 5.437 110.1 13.93 106.2L232.5 5.171zM498.1 234.2C506.6 238.1 512 246.6 512 255.1C512 265.3 506.6 273.8 498.1 277.8L279.5 378.8C264.6 385.7 247.4 385.7 232.5 378.8L13.93 277.8C5.438 273.8 0 265.3 0 255.1C0 246.6 5.437 238.1 13.93 234.2L67.13 209.6L219.1 279.8C242.5 290.7 269.5 290.7 292.9 279.8L444.9 209.6L498.1 234.2zM292.9 407.8L444.9 337.6L498.1 362.2C506.6 366.1 512 374.6 512 383.1C512 393.3 506.6 401.8 498.1 405.8L279.5 506.8C264.6 513.7 247.4 513.7 232.5 506.8L13.93 405.8C5.438 401.8 0 393.3 0 383.1C0 374.6 5.437 366.1 13.93 362.2L67.13 337.6L219.1 407.8C242.5 418.7 269.5 418.7 292.9 407.8V407.8z" />
          </svg>
        </div>
        <div>
          <div className="laboral-stat-value">{statusCounts?.convenios ?? 0}</div>
          <div className="laboral-stat-label">Todo</div>
        </div>
      </div>
    </Card>

  </div>
</div>
            {/* Subfiltros de Concluidos */}
            <div className={`laboral-substats-wrap ${statusFilter === "concluidos" ? "is-open" : ""}`}>
              <div className="laboral-stats-row laboral-substats-row">
           

                <Card
                  className={`laboral-stat-card ${concluidosSubFilter === "archivo_patron" ? "laboral-stat-active" : ""}`}
                  bodyStyle={{ padding: 0 }}
                  onClick={() => {
                    setConcluidosSubFilter((prev) => (prev === "archivo_patron" ? "todos" : "archivo_patron"));
                    setCurrentPage(1);
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="laboral-stat-icon d-inline-flex align-items-center justify-content-center"
                      style={{ background: "#F3F4F6", color: "#111827" }}
                    >
                      <svg viewBox="0 0 640 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM577.9 223.1l47.03-47.03c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L544 190.1l-47.03-47.03c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l47.03 47.03l-47.03 47.03c-9.375 9.375-9.375 24.56 0 33.94c9.373 9.373 24.56 9.381 33.94 0L544 257.9l47.03 47.03c9.373 9.373 24.56 9.381 33.94 0c9.375-9.375 9.375-24.56 0-33.94L577.9 223.1z" />
                      </svg>
                    </div>
                    <div>
                      <div className="laboral-stat-value">{statusCounts?.archivoPatron ?? 0}</div>
                      <div className="laboral-stat-label">Archivo por incomparecencia (patrón)</div>
                    </div>
                  </div>
                </Card>

                <Card
                  className={`laboral-stat-card ${concluidosSubFilter === "archivo_trabajador" ? "laboral-stat-active" : ""}`}
                  bodyStyle={{ padding: 0 }}
                  onClick={() => {
                    setConcluidosSubFilter((prev) => (prev === "archivo_trabajador" ? "todos" : "archivo_trabajador"));
                    setCurrentPage(1);
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="laboral-stat-icon d-inline-flex align-items-center justify-content-center"
                      style={{ background: "#F3F4F6", color: "#111827" }}
                    >
                      <svg viewBox="0 0 640 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM577.9 223.1l47.03-47.03c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L544 190.1l-47.03-47.03c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l47.03 47.03l-47.03 47.03c-9.375 9.375-9.375 24.56 0 33.94c9.373 9.373 24.56 9.381 33.94 0L544 257.9l47.03 47.03c9.373 9.373 24.56 9.381 33.94 0c9.375-9.375 9.375-24.56 0-33.94L577.9 223.1z" />
                      </svg>
                    </div>
                    <div>
                      <div className="laboral-stat-value">{statusCounts?.archivoTrabajador ?? 0}</div>
                      <div className="laboral-stat-label">Archivo por incomparecencia (trabajador)</div>
                    </div>
                  </div>
                </Card>

                <Card
                  className={`laboral-stat-card ${
                    concluidosSubFilter === "constancia_no_conciliacion" ? "laboral-stat-active" : ""
                  }`}
                  bodyStyle={{ padding: 0 }}
                  onClick={() => {
                    setConcluidosSubFilter((prev) =>
                      prev === "constancia_no_conciliacion" ? "todos" : "constancia_no_conciliacion"
                    );
                    setCurrentPage(1);
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="laboral-stat-icon d-inline-flex align-items-center justify-content-center"
                      style={{ background: "#F3F4F6", color: "#111827" }}
                    >
                      <svg viewBox="0 0 576 512" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V198.6C310.1 219.5 256 287.4 256 368C256 427.1 285.1 479.3 329.7 511.3C326.6 511.7 323.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256zM288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368zM491.3 331.3C497.6 325.1 497.6 314.9 491.3 308.7C485.1 302.4 474.9 302.4 468.7 308.7L432 345.4L395.3 308.7C389.1 302.4 378.9 302.4 372.7 308.7C366.4 314.9 366.4 325.1 372.7 331.3L409.4 368L372.7 404.7C366.4 410.9 366.4 421.1 372.7 427.3C378.9 433.6 389.1 433.6 395.3 427.3L432 390.6L468.7 427.3C474.9 433.6 485.1 433.6 491.3 427.3C497.6 421.1 497.6 410.9 491.3 404.7L454.6 368L491.3 331.3z" />
                      </svg>
                    </div>
                    <div>
                      <div className="laboral-stat-value">{statusCounts?.constanciaNoConciliacion ?? 0}</div>
                      <div className="laboral-stat-label">Constancia de no conciliación</div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>

            <div className="viewWrap">
              <div className="viewWrap__header">
                <div className="viewWrap__title">
                  <h2 className="sectionTitle">Expedientes ({totalEncontrados})</h2>
                  <div className="sectionMeta">{totalEncontrados} encontrados</div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
                  <Button
                    danger
                    ghost
                    size="large"
                    className={`laboral-btn-create laboral-btn-vencidos${statusFilter === "vencidos" ? " active" : ""}`}
                    onClick={() => {
                      setStatusFilter((prev) => (prev === "vencidos" ? "todos" : "vencidos"));
                      setConcluidosSubFilter("todos");
                      setCurrentPage(1);
                    }}
                  >
                    <svg className="me-1" viewBox="0 0 512 512" width="13" height="13" fill="currentColor" aria-hidden="true" style={{ verticalAlign: "-1px" }}>
                      <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM175 208.1L222.1 255.1L175 303C165.7 312.4 165.7 327.6 175 336.1C184.4 346.3 199.6 346.3 208.1 336.1L255.1 289.9L303 336.1C312.4 346.3 327.6 346.3 336.1 336.1C346.3 327.6 346.3 312.4 336.1 303L289.9 255.1L336.1 208.1C346.3 199.6 346.3 184.4 336.1 175C327.6 165.7 312.4 165.7 303 175L255.1 222.1L208.1 175C199.6 165.7 184.4 165.7 175 175C165.7 184.4 165.7 199.6 175 208.1V208.1z" />
                    </svg>
                    Vencidos ({statusCounts?.vencidos ?? 0})
                  </Button>
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      className: "laboral-export-menu",
                      items: [
                        {
                          key: "export",
                          label: (
                            <ExportMenuRow
                              viewBox="0 0 384 512"
                              path="M88 304H80V256H88C101.3 256 112 266.7 112 280C112 293.3 101.3 304 88 304zM192 256H200C208.8 256 216 263.2 216 272V336C216 344.8 208.8 352 200 352H192V256zM224 0V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H224zM64 224C55.16 224 48 231.2 48 240V368C48 376.8 55.16 384 64 384C72.84 384 80 376.8 80 368V336H88C118.9 336 144 310.9 144 280C144 249.1 118.9 224 88 224H64zM160 368C160 376.8 167.2 384 176 384H200C226.5 384 248 362.5 248 336V272C248 245.5 226.5 224 200 224H176C167.2 224 160 231.2 160 240V368zM288 224C279.2 224 272 231.2 272 240V368C272 376.8 279.2 384 288 384C296.8 384 304 376.8 304 368V320H336C344.8 320 352 312.8 352 304C352 295.2 344.8 288 336 288H304V256H336C344.8 256 352 248.8 352 240C352 231.2 344.8 224 336 224H288zM256 0L384 128H256V0z"
                              tone="primary"
                              title="Exportar PDF"
                              subtitle="Genera un reporte de los expedientes filtrados"
                            />
                          ),
                          disabled: !selectedAutoridadId || !canConsultar,
                          onClick: handleExportNow,
                        },
                        ...(canInsertar ? [
                        { type: "divider" },
                        {
                          key: "importAI",
                          label: (
                            <ExportMenuRow
                              viewBox="0 0 640 512"
                              path="M9.375 233.4C3.375 239.4 0 247.5 0 256v128c0 8.5 3.375 16.62 9.375 22.62S23.5 416 32 416h32V224H32C23.5 224 15.38 227.4 9.375 233.4zM464 96H352V32c0-17.62-14.38-32-32-32S288 14.38 288 32v64H176C131.8 96 96 131.8 96 176V448c0 35.38 28.62 64 64 64h320c35.38 0 64-28.62 64-64V176C544 131.8 508.3 96 464 96zM256 416H192v-32h64V416zM224 296C201.9 296 184 278.1 184 256S201.9 216 224 216S264 233.9 264 256S246.1 296 224 296zM352 416H288v-32h64V416zM448 416h-64v-32h64V416zM416 296c-22.12 0-40-17.88-40-40S393.9 216 416 216S456 233.9 456 256S438.1 296 416 296zM630.6 233.4C624.6 227.4 616.5 224 608 224h-32v192h32c8.5 0 16.62-3.375 22.62-9.375S640 392.5 640 384V256C640 247.5 636.6 239.4 630.6 233.4z"
                              tone="teal"
                              title="Importar con AI"
                              subtitle="Sube un documento y la IA lo captura"
                            />
                          ),
                          onClick: () => setImportAIModalOpen(true),
                        },
                        {
                          key: "importExcel",
                          label: (
                            <ExportMenuRow
                              viewBox="0 0 384 512"
                              path="M224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM272.1 264.4L224 344l48.99 79.61C279.6 434.3 271.9 448 259.4 448h-26.43c-5.557 0-10.71-2.883-13.63-7.617L192 396l-27.31 44.38C161.8 445.1 156.6 448 151.1 448H124.6c-12.52 0-20.19-13.73-13.63-24.39L160 344L111 264.4C104.4 253.7 112.1 240 124.6 240h26.43c5.557 0 10.71 2.883 13.63 7.613L192 292l27.31-44.39C222.2 242.9 227.4 240 232.9 240h26.43C271.9 240 279.6 253.7 272.1 264.4zM256 0v128h128L256 0z"
                              tone="green"
                              title="Importar Excel"
                              subtitle="Carga masiva desde una plantilla"
                            />
                          ),
                          onClick: () => setImportModalOpen(true),
                        },
                        ] : []),
                      ],
                    }}
                  >
                    <Button size="large" className="laboral-btn-create">
                      <svg className="me-1" viewBox="0 0 256 512" width="7" height="13" fill="currentColor" aria-hidden="true" style={{ verticalAlign: "-1px" }}>
                        <path d="M249.6 392.3l-104 112c-9.094 9.781-26.09 9.781-35.19 0l-103.1-112c-6.484-6.984-8.219-17.17-4.406-25.92S14.45 352 24 352H80V160H24C14.45 160 5.812 154.3 1.999 145.6C-1.813 136.8-.0781 126.7 6.406 119.7l104-112c9.094-9.781 26.09-9.781 35.19 0l104 112c6.484 6.984 8.219 17.17 4.406 25.92C250.2 154.3 241.5 160 232 160H176v192h56c9.547 0 18.19 5.656 22 14.41S256.1 385.3 249.6 392.3z" />
                      </svg>
                      Exportar / Importar
                    </Button>
                  </Dropdown>
                  <ImportarExcelModal
                    open={importModalOpen}
                    onClose={() => setImportModalOpen(false)}
                    onSuccess={() => dispatch(actionConciliacionGet(filtrosBusqueda))}
                    context={{
                      estado:            selectedEstadoId !== ALL ? selectedEstadoId : undefined,
                      ciudad:            selectedCiudadId !== ALL ? selectedCiudadId : undefined,
                      autoridad:         selectedAutoridadId !== ALL ? selectedAutoridadId : undefined,
                      tipo_conciliacion: tipoConfig.key,
                    }}
                  />
                  <ImportarAIModal
                    open={importAIModalOpen}
                    onClose={() => setImportAIModalOpen(false)}
                    onSuccess={() => dispatch(actionConciliacionGet(filtrosBusqueda))}
                    context={{
                      estado:            selectedEstadoId !== ALL ? selectedEstadoId : undefined,
                      ciudad:            selectedCiudadId !== ALL ? selectedCiudadId : undefined,
                      autoridad:         selectedAutoridadId !== ALL ? selectedAutoridadId : undefined,
                      tipo_conciliacion: tipoConfig.key,
                    }}
                  />
                  <Select
                    className="laboral-control laboral-sort-control"
                    size="large"
                    style={{ width: 240 }}
                    popupMatchSelectWidth={false}
                    value={sortOption}
                    onChange={(value) => {
                      setSortOption(value || "default");
                      setCurrentPage(1);
                    }}
                    options={[
                      { value: "default", label: "Ordenar por" },
                      { value: "az", label: "Nombre (A-Z)" },
                      { value: "za", label: "Nombre (Z-A)" },
                      { value: "audiencia_asc", label: "Fecha de audiencia · más antigua" },
                      { value: "audiencia_desc", label: "Fecha de audiencia · más reciente" },
                      { value: "subido_asc", label: "Fecha de subido · más antigua" },
                      { value: "subido_desc", label: "Fecha de subido · más reciente" },
                      { value: "citatorio_asc", label: "Fecha de emisión de citatorio · más antigua" },
                      { value: "citatorio_desc", label: "Fecha de emisión de citatorio · más reciente" },
                    ]}
                  />
                  <Segmented
                    className="laboral-segmented"
                    value={view}
                    onChange={setView}
                    options={[
                      {
                        value: "cards",
                        label: (
                          <span className="laboral-segmented-option">
                            <svg viewBox="0 0 320 512" width="8" height="13" fill="currentColor" aria-hidden="true">
                              <path d="M88 352C110.1 352 128 369.9 128 392V440C128 462.1 110.1 480 88 480H40C17.91 480 0 462.1 0 440V392C0 369.9 17.91 352 40 352H88zM280 352C302.1 352 320 369.9 320 392V440C320 462.1 302.1 480 280 480H232C209.9 480 192 462.1 192 440V392C192 369.9 209.9 352 232 352H280zM40 320C17.91 320 0 302.1 0 280V232C0 209.9 17.91 192 40 192H88C110.1 192 128 209.9 128 232V280C128 302.1 110.1 320 88 320H40zM280 192C302.1 192 320 209.9 320 232V280C320 302.1 302.1 320 280 320H232C209.9 320 192 302.1 192 280V232C192 209.9 209.9 192 232 192H280zM40 160C17.91 160 0 142.1 0 120V72C0 49.91 17.91 32 40 32H88C110.1 32 128 49.91 128 72V120C128 142.1 110.1 160 88 160H40zM280 32C302.1 32 320 49.91 320 72V120C320 142.1 302.1 160 280 160H232C209.9 160 192 142.1 192 120V72C192 49.91 209.9 32 232 32H280z" />
                            </svg>
                            Tarjetas
                          </span>
                        ),
                      },
                      {
                        value: "table",
                        label: (
                          <span className="laboral-segmented-option">
                            <svg viewBox="0 0 512 512" width="13" height="13" fill="currentColor" aria-hidden="true">
                              <path d="M448 32C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H448zM224 256V160H64V256H224zM64 320V416H224V320H64zM288 416H448V320H288V416zM448 256V160H288V256H448z" />
                            </svg>
                            Tabla
                          </span>
                        ),
                      },
                    ]}
                  />
                </div>
              </div>

              {view === "table" ? (
                <TableView
                  pageRows={rows}
                  total={totalEncontrados}
                  totalPages={totalPages}
                  page={currentPage}
                  setPage={setCurrentPage}
                />
              ) : (
                <CardsView
                  rows={rows}
                  total={totalEncontrados}
                  totalPages={totalPages}
                  page={currentPage}
                  setPage={setCurrentPage}
                />
              )}
            </div>
        </div>
      </main>
    </div>
    </ConfigProvider>
  );
}

const KPI_BG_VARIANT = { blue: "info", green: "success", gray: "secondary", yellow: "warning", red: "danger", primary: "primary" };

const KPI_ICON_COLORS = {
  primary: { bg: "#DCE9F5", fg: "#0A539A" },
  success: { bg: "#16A34A26", fg: "#16A34A" },
  secondary: { bg: "#F3F4F6", fg: "#6B7280" },
  warning: { bg: "#FEF3C7", fg: "#F59E0B" },
  danger: { bg: "#FEE2E2", fg: "#DC2626" },
  info: { bg: "#e6f4ff", fg: "#1677ff" },
};

function KpiCardConc({ icon, iconSvg, iconBg, value, label, active = false, onClick }) {
  const variant = KPI_BG_VARIANT[iconBg] || "secondary";
  const iconColors = KPI_ICON_COLORS[variant] || KPI_ICON_COLORS.secondary;
  return (
    <Card
      role={onClick ? "button" : undefined}
      onClick={onClick}
      bodyStyle={{ display: "flex", alignItems: "center", gap: 12 }}
      style={{
        cursor: onClick ? "pointer" : "default",
        borderColor: active ? "#0A539A" : undefined,
        borderWidth: active ? 2 : undefined,
      }}
    >
      <span
        className="d-inline-flex align-items-center justify-content-center"
        style={{ width: 44, height: 44, background: iconColors.bg, color: iconColors.fg }}
      >
        {iconSvg || <i className={`bi ${icon} fs-5`} />}
      </span>
      <div>
        <div className="fs-4 fw-bold lh-1">{value}</div>
        <div className="small text-secondary">{label}</div>
      </div>
    </Card>
  );
}

const STATUS_PILL_HEX = {
  green: "#16A34A",
  red: "#DC2626",
  blue: "#1677ff",
  yellow: "#F59E0B",
  gray: "#6B7280",
  black: "#111827",
};

function StatusPillConc({ kind, icon, label }) {
  return (
    <DataBadge
      color={STATUS_PILL_HEX[kind] || kind}
      className="d-inline-flex align-items-center gap-1 status-pill-badge"
    >
      {label}
    </DataBadge>
  );
}
